var map = {
	"./artsy-colorado-couple.jpg": 4100,
	"./colorado-couple-hugging-married.jpg": 765,
	"./colorado-couple-outdoors-hugging.jpg": 3172,
	"./colorado-couple-profile-artsy.jpg": 2017,
	"./colorado-sunset-couple.jpg": 2817,
	"./couple-artsy-colorado-outdoors-stare.jpg": 437,
	"./dancing-couple-lake-colorado.jpg": 6460,
	"./denver-colorado-lake-couple-laugh.jpg": 997,
	"./denver-lake-dance-couple-colorado.jpg": 1020,
	"./laughing-colorado-couple-nature.jpg": 5472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6628;